import { Component, type ReactNode } from 'react'
import clsx from 'clsx'
import Button from '../ui/buttons/Button'

type SceneErrorBoundaryProps = {
    children: ReactNode
}

type SceneErrorBoundaryState = {
    message: string | null
}

// corrupt asset loader error fallback
export default class SceneErrorBoundary extends Component<
    SceneErrorBoundaryProps,
    SceneErrorBoundaryState
> {
    state: SceneErrorBoundaryState = { message: null }

    static getDerivedStateFromError(error: unknown): SceneErrorBoundaryState {
        return {
            message: error instanceof Error ? error.message : String(error),
        }
    }

    componentDidCatch(error: unknown) {
        console.error('[scene] render failed', error)
    }

    render() {
        if (this.state.message === null) {
            return this.props.children
        }

        return (
            <div
                className={clsx(
                    'z-999998 fixed inset-0 flex flex-col items-center justify-center',
                    'gap-4 bg-slate-800 px-6 text-center',
                    'stele:gap-12 stele:px-24',
                )}
            >
                <p className='font-nunito font-bold text-[18px] text-white stele:text-[48px]'>
                    Die Szene konnte nicht geladen werden.
                </p>
                <p className='max-w-full font-mono text-[10px] text-red-300 stele:text-[24px] break-all'>
                    {this.state.message}
                </p>
                <Button onClick={() => window.location.reload()}>
                    Neu laden
                </Button>
            </div>
        )
    }
}
